import DSBox from "views/system-design/DSBox";
import DSChip from "views/system-design/DSChip";
import { REPO_LABELS, LABEL_COLORS } from "../../types";

interface LabelChipsProps {
  selectedLabels: string[];
  onToggleLabel: (label: string) => void;
}

export default function LabelChips({
  selectedLabels,
  onToggleLabel,
}: LabelChipsProps) {
  return (
    <DSBox sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
      {REPO_LABELS.map((label) => {
        const isSelected = selectedLabels.includes(label);
        return (
          <DSChip
            key={label}
            label={label}
            size="small"
            variant={isSelected ? "filled" : "outlined"}
            onClick={() => onToggleLabel(label)}
            sx={{
              cursor: "pointer",
              ...(isSelected && {
                bgcolor: LABEL_COLORS[label] ?? "grey.500",
                color: "common.white",
                fontWeight: 600,
              }),
            }}
          />
        );
      })}
    </DSBox>
  );
}
